import Link from 'next/link';
import styles from './ArticleAthleteBox.module.scss';

export type ArticlePerson = {
  slug: string;
  name: string;
  avatarURL?: string | null;
};

type ArticleAthleteBoxProps = {
  person: ArticlePerson;
  label: string;
};

const AVATAR_PLACEHOLDER = '/images/icons/avatar-placeholder.svg';

const ArticleAthleteBox = ({
  person,
  label,
}: ArticleAthleteBoxProps): JSX.Element => (
  <Link href={`/${person.slug}`} prefetch={false}>
    <a className={styles.root}>
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        className={styles.avatar}
        src={person.avatarURL || AVATAR_PLACEHOLDER}
        alt=""
      />
      <span className={styles.text}>
        <span className={styles.label}>{label}</span>
        <h3 className={styles.name}>{person.name}</h3>
      </span>
      <span className={styles.cta}>View profile</span>
    </a>
  </Link>
);

export default ArticleAthleteBox;
